const qRawText = [
  "Q - 독사의 칼날",
  "에키온이 좁은 범위의 VF를 방출해 스킬 피해를 입힙니다. 적 대상에게 피해를 입히면 다음 3초 안에 스킬을 재사용할 수 있습니다.",
  "재사용 시: 넓은 범위의 VF를 방출해 스킬 피해를 입히고, 대상의 이동 속도를 1초 동안 감소시킵니다.",
  "과부하 상태가 되면 VF가 방출되지 않습니다.",
  "",
  "1타 피해량 [20 / 35 / 50 / 65 / 80] (+공격력의 50%)",
  "2타 피해량 [40 / 60 / 80 / 100 / 120] (+공격력의 65%)",
  "VF게이지 증가량 [12, 16 / 13, 18 / 14, 20 / 15, 22 / 16, 24]",
  "이동속도 감소량(%) [5% / 10% / 15% / 20% / 25%]",
  "투사체 속도: 16.3m/s",
  "재사용 시 투사체 속도: 17m/s",
  "범위: 9m * 1m",
  "재사용 시 범위: 7m * 1.5m",
  "과부하 상태: 투사체가 발사되지 않으며 사거리가 2m로 감소",
  "쿨다운: 6초",
].join("\n\n");

const normalizeDescription = (text) => (
  text
    .replace(/\r\n/g, "\n")
    .replace(/\t/g, "")
    .replace(/[ ]{2,}/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim()
);

const qDescription = normalizeDescription(`
  Q - 독사의 칼날
  에키온이 좁은 범위의 VF를 방출해 스킬 피해를 입힙니다. 적 대상에게 피해를 입히면 다음 3초 안에 스킬을 재사용할 수 있습니다.
  재사용 시: 넓은 범위의 VF를 방출해 스킬 피해를 입히고, 대상의 이동 속도를 1초 동안 감소시킵니다.
  과부하 상태가 되면 VF가 방출되지 않습니다.
  
  1타 피해량 [20 / 35 / 50 / 65 / 80] (+공격력의 50%)
  2타 피해량 [40 / 60 / 80 / 100 / 120] (+공격력의 65%)
  VF게이지 증가량 [12, 16 / 13, 18 / 14, 20 / 15, 22 / 16, 24]
  이동속도 감소량(%) [5% / 10% / 15% / 20% / 25%]

  과부하 상태: 투사체가 발사되지 않으며 사거리가 2m로 감소
`);

const qLevelData = [
  { firstHit: 20, secondHit: 40, vfGaugeGain: [12, 16], moveSpeedSlowPercent: 5 },
  { firstHit: 35, secondHit: 60, vfGaugeGain: [13, 18], moveSpeedSlowPercent: 10 },
  { firstHit: 50, secondHit: 80, vfGaugeGain: [14, 20], moveSpeedSlowPercent: 15 },
  { firstHit: 65, secondHit: 100, vfGaugeGain: [15, 22], moveSpeedSlowPercent: 20 },
  { firstHit: 80, secondHit: 120, vfGaugeGain: [16, 24], moveSpeedSlowPercent: 25 },
];

const createQSkill = () => ({
  name: "독사의 칼날",
  description: qDescription,
  rawText: qRawText,
  maxLevel: 5,
  levels: qLevelData.reduce((levels, levelData, index) => ({
    ...levels,
    [index + 1]: {
      hits: [
        {
          label: "1타",
          baseDamage: levelData.firstHit,
          attackPowerRatio: 0.5,
          damageType: "skill",
        },
        {
          label: "2타",
          baseDamage: levelData.secondHit,
          attackPowerRatio: 0.65,
          damageType: "skill",
        },
      ],
      vfGaugeGain: levelData.vfGaugeGain,
      moveSpeedSlowPercent: levelData.moveSpeedSlowPercent,
      cooldown: 6,
    },
  }), {}),
});

const createWSkill = () => ({
  name: "뒤집힌 비늘",
  description: [
    "에키온이 최대 50의 VF게이지를 소모해 자신의 몸을 보호하는 보호막을 생성합니다. 소모한 VF의 200% 만큼 보호막의 흡수량이 증가합니다.",
    "생성된 보호막의 100% 이상 피해를 흡수하면 소모한 VF게이지의 일부를 돌려받습니다.",
    "",
    "보호막 흡수량 [20 / 40 / 60 / 80 / 100] (+공격력의 50%)",
    "돌려받는 VF게이지(%) [60% / 70% / 80% / 90% / 100%]",
    "쿨다운 [10 / 9.5 / 9 / 8.5 / 8]",
    "보호막 유지 시간: 2초",
  ].join("\n"),
  rawText: [
    "W - 뒤집힌 비늘[편집]",
    "에키온이 최대 50의 VF게이지를 소모해 자신의 몸을 보호하는 보호막을 생성합니다. 소모한 VF의 200% 만큼 보호막의 흡수량이 증가합니다.",
    "생성된 보호막의 100% 이상 피해를 흡수하면 소모한 VF게이지의 일부를 돌려받습니다.",
    "보호막 흡수량 [20 / 40 / 60 / 80 / 100] (+공격력의 50%)",
    "돌려받는 VF게이지(%) [60% / 70% / 80% / 90% / 100%]",
    "쿨다운 [10 / 9.5 / 9 / 8.5 / 8]",
    "보호막 유지 시간: 2초",
  ].join("\n"),
  maxLevel: 5,
  levels: [20, 40, 60, 80, 100].reduce((levels, shield, index) => ({
    ...levels,
    [index + 1]: {
      shield,
      attackPowerRatio: 0.5,
      vfGaugeReturnPercent: [60, 70, 80, 90, 100][index],
      cooldown: [10, 9.5, 9, 8.5, 8][index],
      duration: 2,
    },
  }), {}),
});

const createESkill = () => ({
  name: "메마른 송곳니",
  description: [
    "지정한 방향으로 돌진하며 경로상의 적들에게 스킬 피해를 입히고, 표식이 없는 대상에게 피해를 입혔다면 쿨다운을 초기화합니다. 가장 처음 적중한 대상에게 6초 동안 유지되는 표식을 남깁니다.",
    "",
    "과부하 상태가 되면 돌진의 거리가 감소합니다.",
    "",
    "피해량 [20 / 35 / 50 / 65 / 80] (+공격력의 40%)",
    "VF게이지 증가 [16 / 17 / 18 / 19 / 20]",
    "쿨다운 [16 / 15 / 14 / 13 / 12]",
    "이동 거리: 4.5m / 3.5m (과부하 상태)",
    "이동 시간: 0.36초",
  ].join("\n"),
  rawText: [
    "E - 메마른 송곳니",
    "지정한 방향으로 돌진하며 경로상의 적들에게 스킬 피해를 입히고, 표식이 없는 대상에게 피해를 입혔다면 쿨다운을 초기화합니다. 가장 처음 적중한 대상에게 6초 동안 유지되는 표식을 남깁니다.",
    "",
    "과부하 상태가 되면 돌진의 거리가 감소합니다.",
    "피해량 [20 / 35 / 50 / 65 / 80] (+공격력의 40%)",
    "VF게이지 증가 [16 / 17 / 18 / 19 / 20]",
    "쿨다운 [16 / 15 / 14 / 13 / 12]",
    "이동 거리: 4.5m / 3.5m (과부하 상태)",
    "이동 시간: 0.36초",
  ].join("\n"),
  maxLevel: 5,
  levels: [20, 35, 50, 65, 80].reduce((levels, baseDamage, index) => ({
    ...levels,
    [index + 1]: {
      hits: [
        {
          label: "피해량",
          baseDamage,
          attackPowerRatio: 0.4,
          damageType: "skill",
        },
      ],
      vfGaugeGain: [16, 17, 18, 19, 20][index],
      cooldown: [16, 15, 14, 13, 12][index],
      moveDistance: 4.5,
      overloadMoveDistance: 3.5,
      moveDuration: 0.36,
    },
  }), {}),
});

const rCommonRawText = [
  "R 공통사항 ",
  "VF폭주",
  "지속 효과: 에키온이 독사의 칼날(Q), 메마른 송곳니(E)를 사용할 때 VF게이지가 증가하고,", 
  "VF게이지 1당 스킬의 피해량이 [0.3%/0.5%/0.7%/0.9%] 증가합니다.",
  "VF게이지가 가득차면 9초 동안 VF폭주 상태가 되고 피해량 증가 값이 최대로 적용됩니다.",
  "",
  "VF폭주: 에키온이 폭주하여 이동 속도가 5% 증가하고, 에키온 반경 2m 적에게 0.5초마다 [7 / 10 / 13 / 16] (+공격력의 7%) 의 고정 피해를 입히며,",
  "독사의 진노(R)를 사용할 수 있게 됩니다. 또한 메마른 송곳니(E)의 쿨다운이 초기화됩니다.",
  "VF폭주 상태에서 적을 처치하면 폭주의 지속 시간이 5초 연장되고 메마른 송곳니(E)의 쿨다운이 초기화됩니다. 50% 감소합니다.",
  "",
  "과부하: 폭주가 끝나면 8초 동안 과부하 상태가 되어 기본 공격 사거리가 0.3 감소하고 VF게이지가 증가하지 않게 됩니다.",
  "",
  "쿨다운 고정: 쿨다운 감소 스탯의 영향을 받지 않습니다.",
  "비전투 상태 VF게이지 감소량: 초당 2",
  "독사의 진노 공격 범위: 6m * 1.2m"
].join("\n");

const createRSkill = ({
  attackPowerRatio = 0,
  baseDamages,
  cooldown,
  damageLabel = "독사의 진노 피해량",
  descriptionLines,
  extra = {},
  maxLevel = 4,
  name = "독사의 진노",
}) => ({
  name,
  description: [...descriptionLines, "", rCommonRawText].join("\n"),
  rawText: [...descriptionLines, "", rCommonRawText].join("\n"),
  maxLevel,
  levels: baseDamages.slice(0, maxLevel).reduce((levels, baseDamage, index) => ({
    ...levels,
    [index + 1]: {
      hits: [
        {
          label: damageLabel,
          baseDamage,
          attackPowerRatio,
          bonusAttackPowerRatio: Array.isArray(extra.bonusAttackPowerRatio) ? extra.bonusAttackPowerRatio[index] : 0,
          bonusHealthRatio: Array.isArray(extra.bonusHealthRatio) ? extra.bonusHealthRatio[index] : 0,
          damageType: "skill",
        },
      ],
      cooldown,
      fixedDamagePerTick: [7, 10, 13, 16][index],
      fixedDamageAttackPowerRatio: 0.07,
      ...Object.fromEntries(Object.entries(extra).map(([key, values]) => [
        key,
        Array.isArray(values) ? values[index] : values,
      ])),
    },
  }), {}),
  rawParsedValues: {
    baseDamages,
    ...extra,
  },
});

const createPassiveSkill = (name, lines) => ({
  name,
  description: lines.join("\n"),
  rawText: lines.join("\n"),
  maxLevel: 1,
  fixedLevel: 1,
  isPassive: true,
  levels: {
    1: {
      cooldown: 0,
    },
  },
});

export const echionSkills = {
  common: {
    Q: createQSkill(),
    W: createWSkill(),
    E: createESkill(),
  },

  deathadder: {
    R: createRSkill({
      attackPowerRatio: 0.9,
      baseDamages: [90, 200, 250, 300],
      cooldown: 3,
      damageLabel: "데스애더 피해량",
      descriptionLines: [
        "데스애더 R",
        "지정한 방향으로 제어 불가능한 VF를 방출해 스킬 피해를 입힙니다. 독사의 진노가 적 실험체에게 피해를 입히면 폭주의 지속 시간을 1초 연장시킵니다.",
        "기본 공격으로 피해를 입힐 때마다 독사의 진노 쿨다운을 0.5초 감소시킵니다.",
        "독사의 진노 피해량 [90 / 200 / 250 / 300] (+공격력의 90%)",
        "공격 속도 증가량(%) [8% / 10% / 12% / 14%]",
        "쿨다운: 3초",
      ],
      extra: {
        attackSpeedIncreasePercent: [8, 10, 12, 14],
      },
    }),
    P: createPassiveSkill("카드모스의 부름 [데스애더]", [
      "데스애더 P",
      "에키온이 스킬로 적에게 피해를 입히면 5초 동안 공격 속도가 증가하는 전투광 중첩을 1 얻습니다. VF폭주 상태에서 기본 공격이 공격력의 40% * (기본 공격 증폭)의 기본 공격 피해를 연속으로 입히고, 독사의 진노(R)를 사용하면서 이동할 수 있습니다.",
      "데스애더 계열의 무기는 VF폭주 상태에서 의념 효과가 발동합니다.",
    ]),
  },

  sidewinder: {
    R: createRSkill({
      attackPowerRatio: 0,
      baseDamages: [40, 80, 125, 170],
      cooldown: 3,
      damageLabel: "사이드와인더 피해량",
      descriptionLines: [
        "사이드 와인더 R",
        "지정한 방향으로 제어 불가능한 VF를 방출해 스킬 피해를 입히고, 1초에 걸쳐 이동 속도를 90% 감소시킵니다. 독사의 진노가 적 실험체에게 피해를 입히면 폭주의 지속 시간을 1초 연장시킵니다.",
        "기본 공격으로 피해를 입힐 때마다 독사의 진노 쿨다운을 0.5초 감소시킵니다.",
        "독사의 진노 피해량 [40 / 80 / 125 / 170] (+추가 공격력의 200%)",
        "스킬 공격 추가 피해 [20% / 30% / 40% / 50%]",
        "쿨다운: 3초",
      ],
      extra: {
        bonusAttackPowerRatio: [2, 2, 2, 2],
        skillAttackBonusDamagePercent: [20, 30, 40, 50],
      },
    }),
    P: createPassiveSkill("카드모스의 부름 [사이드와인더]", [
      "사이드와인더 P",
      "스킬 적중 시, 대상에게 입힌 피해의 일부만큼 추가 스킬 피해를 입힙니다. 뒤집힌 비늘(W)의 쿨다운이 영구적으로 15%만큼 감소합니다.",
      "사이드와인더 계열의 무기는 VF폭주 상태에서 가벼운 발걸음 효과가 발동합니다.",
    ]),
  },

  blackmamba: {
    R: createRSkill({
      attackPowerRatio: 0.8,
      baseDamages: [50, 120, 175, 220],
      cooldown: 4,
      damageLabel: "블랙맘바 피해량",
      descriptionLines: [
        "블랙맘바 R",
        "지정한 방향으로 제어 불가능한 VF를 방출해 스킬 피해를 입힙니다. 0.85초 뒤 한 번 더 독사의 진노가 발생하여 기존 피해량의 일부만큼 피해를 입히고 대상을 0.75초 동안 공중에 띄웁니다.",
        "독사의 진노가 적 실험체에게 피해를 입히면 폭주의 지속 시간을 1초 연장시킵니다.",
        "기본 공격으로 피해를 입힐 때마다 독사의 진노 쿨다운을 0.5초 감소시킵니다.",
        "독사의 진노 피해량 [40 / 80 / 125 / 170] (+공격력의 80%) (+추가 체력의 12%)",
        "독사의 진노 추가 피해량(%) [55% / 70% / 85% / 100%]",
        "스킬 피해 흡혈량(%) [10% / 14% / 18% / 22%]",
        "쿨다운: 4초",
      ],
      extra: {
        bonusHealthRatio: [0.12, 0.12, 0.12, 0.12],
        extraDamagePercent: [55, 70, 85, 100],
        skillDamageVampPercent: [10, 14, 18, 22],
      },
    }),
    P: createPassiveSkill("카드모스의 부름 [블랙맘바]", [
      "블랙맘바 P",
      "에키온이 스킬로 입힌 피해의 일부만큼 체력을 회복하고, 독사의 칼날(Q), 메마른 송곳니(E)가 VF 게이지를 3만큼 추가로 증가시킵니다.",
      "VF폭주의 지속 시간이 4초만큼 증가하며, 독사의 진노(R)가 한 번 더 발생해 추가 피해를 입히고 대상을 공중으로 띄웁니다",
    ]),
  },
};
